// extracted by mini-css-extract-plugin
export default {"negativeEquityTerms":"NegativeEquityTerm__negativeEquityTerms-ArQ7"};